import { Component, OnInit, Input, Output, OnChanges, SimpleChange, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CommentAPIService } from '../../comment/comment.service';
import { CommentJoinDialog } from "../../comment/commentIcon/comment-icon.component";
import { UserInfoService } from '../../user/user-info.service';
import { ESocialType, ESocialSourceType, ESocialIconType, ESocialIconStyle, SocialObjectAPIService } from '../social-object.service';

@Component({
	selector: 'app-social-follow-icon',
	templateUrl: './social-follow-icon.component.html',
	styleUrls: ['./social-follow-icon.scss']
})
export class SocialFollowIconComponent implements OnInit {
	tIconType = ESocialIconType;
	tIconStyle = ESocialIconStyle;

	@Input() source: ESocialSourceType = ESocialSourceType.Map;
	@Input() objectType: ESocialType = ESocialType.Unknown; // default is 0 (unknown), for onet occupation, certification, institution which containing id not from map, caller should provide)
	@Input() objectId: string = ""; // the object being followed
	@Input() clicked: boolean = false; // when click outside????
	@Input() iconType: ESocialIconType = ESocialIconType.Follow;
	@Input() iconStyle: ESocialIconStyle = ESocialIconStyle.Icon;
	@Input() tipPos: "left" | "top" | "bottom" | "" = ""; // display tooltip at left/right/top/bottom default is empty (not display)
	@Input() object: any = null; // for certificateTraining. resource, certificate org, object is required because data directly from CareerOneStop,
	@Output() onToggled: EventEmitter<any> = new EventEmitter(); // when tggle, call back
	@Input() canSocial: boolean = true;
	@Input() provideComment: boolean = false;
	@Input() commentName: string = ""; // required if provideComment

	constructor(
		private commentAPI: CommentAPIService,
		private dialog: MatDialog,
		private socialAPI: SocialObjectAPIService,
		private userInfo: UserInfoService
	) {
		this.isAnonymous = this.userInfo.isAnonymous();
	}

	isAnonymous: boolean = true; 
	dataReady: boolean = false;
	displayIcon: boolean = false;
	loading: boolean = true;
	toolTip: string = ""
	socialStatus: boolean = false;
	private popup: any = null;

	ngOnInit(): void {
		this.source = this.source ?? ESocialSourceType.Map;
		this.objectType = this.objectType ?? ESocialType.Unknown;
		this.iconType = this.iconType ?? ESocialIconType.Follow;
		this.toolTip = this.tipPos === '' ? '' : ESocialIconType[this.iconType];
		this.getStatus();
		this.dataReady = true;
		if (this.provideComment && this.commentName === "") {
			throw "Please provide comment name";
		}
	}

	ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
		if (!this.dataReady) {
			return;
		}
		//this watch provides a way to know if user clicked on some text, such as label from parent of this directive.
		if (changes['clicked'] && this.objectId) {
			if (this.loading === false) {
				this.toggleStatus();
			}
		}
		if (changes['objectId'] && this.objectId) {
			if (this.objectId === '') {
				this.displayIcon = false;
			}
			else {
				this.getStatus();
			}
		}
	}

	toggleStatus(): void {
		if (!this.canSocial) {
			return;
		}

		this.loading = true;
		let following: boolean = !this.socialStatus;
		let follow: boolean = following;
		let socialObject: any = {
			Follow: follow,
			SocialObjectTypeId: this.objectType
		};
		if (this.object != null) {
			switch (this.objectType) {
				case ESocialType.Resource:
					socialObject.Resource = this.object;
					break;
				case ESocialType.CSCProgram:
					socialObject.CSCProgram = this.object;
					break;
				default:
					socialObject = null;
			}
		}
		else {
			socialObject = null;
		}

		if (socialObject != null) {
			this.socialAPI.saveUserSocialObject(socialObject).subscribe({
				next: (response: any) => {
					this.getStatus();
					this.onToggled.emit({ "Status": following, "Type": this.objectType.toString(), "Object": socialObject });
				},
				error: (err: any) => {
					console.log(err);
					this.loading = false;
				}
			});
		}
		else {
			this.socialAPI.saveUserSocialObjectById(this.source.toString(), this.objectType.toString(), this.objectId, follow).subscribe({
				next: (response: any) => {
					this.getStatus();
					this.onToggled.emit({ "Status": following, "Type": this.objectType.toString(), "ObjectId": this.objectId, "Source": this.source.toString() });

					if (this.provideComment)
					{
						if (following) {
							this.popup = this.dialog.open(
								CommentJoinDialog,
								{
									disableClose: true,
									panelClass: "jmDialogNoScroll",
									width: "90%",
									maxWidth: "800px",
									data: {
										objectId: this.objectId,
										objectName: this.commentName
									}
								}
							);
						}
						else {
							// when unfollow, silently remove this account from occupation notification
							this.commentAPI.updateCommentPerson(this.objectId, "delete").subscribe();
						}
					}
				},
				error: (err: any) => {
					console.log(err);
					this.loading = false;
				}
			});
		}
	}

	private getStatus(): void {
		this.socialAPI.isFollowing(this.source.toString(), this.objectType.toString(), this.objectId).subscribe({
			next: (following: any) => {
				this.socialStatus = following;
				this.loading = false;
				this.displayIcon = true;
			},
			error: (err: any) => {
				console.log(err);
				this.loading = false;
				this.socialStatus = false;
				this.displayIcon = false;
			}
		});
	}

	ngOnDestroy() {
		if (this.popup != null) {
			this.popup.close();
		}
	}
}
